function isIncludeResumeSwitchDisabled(form, defaultMinSalary, defaultMaxSalary) {
  const values = form.getFieldsValue();
  const minSalary = form.isFieldTouched('monster-min-salary') ? values['monster-min-salary'] : defaultMinSalary;
  const maxSalary = form.isFieldTouched('monster-max-salary') ? values['monster-max-salary'] : defaultMaxSalary;
  return !(minSalary || maxSalary);
}

export default isIncludeResumeSwitchDisabled;
